import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import EmailEditorModel from '../models/EmailEditorModel';

interface EmailEditorState {
    showEmailEditor: boolean,
    showSignatureEditor: boolean,
    triggerEmailChange: number,
    emailToSend: EmailEditorModel,
}

const initialState: EmailEditorState = {
    showEmailEditor: false,
    showSignatureEditor: false,
    emailToSend: {
        emailFrom: "",
        emailTo: "",
        emailSubject: "",
        emailContent: "",
    } as EmailEditorModel,
    triggerEmailChange: 0,
}

export const EmailEditorSlice = createSlice({
    name: "EmailEditor",
    initialState,
    reducers: {
        setShowEmailEditor: (state, action: PayloadAction<boolean>) => {
            state.showEmailEditor = action.payload;
        },
        setShowSignatureEditor: (state, action: PayloadAction<boolean>) => {
            state.showSignatureEditor = action.payload;
        },
        setEmailFrom: (state, action: PayloadAction<string>) => {
            state.emailToSend.emailFrom = action.payload;
        },
        setEmailTo: (state, action: PayloadAction<string>) => {
            state.emailToSend.emailTo = action.payload;
        },
        setEmailSubject: (state, action: PayloadAction<string>) => {
            state.emailToSend.emailSubject = action.payload;
        },
        setEmailContent: (state, action: PayloadAction<string>) => {
            state.emailToSend.emailContent = action.payload;
        },
        setEmailToSend: (state, action: PayloadAction<EmailEditorModel>) => {
            state.emailToSend = action.payload;
        },
        setTriggerEmailChange: (state, action: PayloadAction<number>) => {
            state.triggerEmailChange = action.payload;
        },
    }
});

export const EmailEditorSelector = createSelector(
    (state: RootState) => state.emailEditor,
    (data) => data
);

export const {
    setShowEmailEditor,
    setShowSignatureEditor,
    setEmailFrom,
    setEmailTo,
    setEmailSubject,
    setEmailContent,
    setEmailToSend,
    setTriggerEmailChange,
} = EmailEditorSlice.actions;

export default EmailEditorSlice.reducer;
